export const MONTHLY_GOAL_EXPIRY_DAYS = 30;
export const MONTHLY_GOAL_REMINDER_DAYS = 15;
export const MONTHLY_GOAL_REMINDER_DISMISSED_KEY = 'proMonthlyGoalReminderDismissed';
export const MONTHLY_GOAL_SURVEY_KEY = 'proMonthlyGoalSurveyCompleted';
